module.exports = __webpack_public_path__ + "static/me-c53e572257cdb0c0f25999d14733fa5d.png";